import classnames from "classnames";
import React, { ReactComponentElement } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";

import { Link } from "common/types/routing";

import { ThemeProps } from "features/common/themes";

import styles from "./RowLayout.module.scss";

type Props = {
  link: Link;
  depth?: 0 | 1 | 2;
  active?: boolean;
  onClick?: () => void;
  responsive?: boolean;
  disabled?: boolean;
  children: {
    title: ReactComponentElement<any, any> | ReactComponentElement<any, any>[];
    indicator:
      | ReactComponentElement<any, any>
      | ReactComponentElement<any, any>[];
  };
};

const ThemeWrapper = styled.div`
  ${({ theme, disabled }: ThemeProps) => `
  .${styles.wrapper}:hover  {
     color: ${disabled ? "initial" : theme["primary-high-content"]}
  }
  `};
`;

export default function RowLayoutLink({
  link,
  depth,
  active,
  onClick,
  responsive,
  disabled,
  children: { title, indicator }
}: Props) {
  const styling = classnames(styles.wrapper, {
    [styles.depthTop]: depth === 0,
    [styles.depthMid]: depth === 1,
    [styles.depthBtm]: depth === 2,
    [styles.responsive]: responsive,
    [styles.active]: active,
    [styles.disabled]: disabled
  });

  return (
    // @ts-ignore
    <ThemeWrapper disabled={disabled}>
      {!disabled ? (
        <NavLink to={link} onClick={onClick} className={styling}>
          <div className={styles.title}>{title}</div>
          <div className={styles.indicator}>{indicator}</div>
        </NavLink>
      ) : (
        <span className={styling}>
          <div className={styles.title}>{title}</div>
          <div className={styles.indicator}>{indicator}</div>
        </span>
      )}
    </ThemeWrapper>
  );
}
